import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "./logo.png";

const Navbar = () => {

const [scrolled, setScrolled] = useState(false);
const [menuOpen, setMenuOpen] = useState(false);

useEffect(() => {
const handleScroll = () => setScrolled(window.scrollY > 40);
window.addEventListener("scroll", handleScroll);
return () => window.removeEventListener("scroll", handleScroll);
}, []);

return (
<>
<nav className={`navbar ${scrolled ? "scrolled" : ""}`}>

{/* LOGO */}
<a href="/" className="logo">
<img src={logo} alt="logo" className="logo-img" />
<span>શ્રી ધનલક્ષ્મી મહિલા કો-ઓપ. ક્રેડિટ સોસાયટી</span>
</a>

{/* TOGGLE BUTTON */}
<div 
className="menu-toggle"
onClick={() => setMenuOpen(!menuOpen)}
>
{menuOpen ? "✕" : "☰"}
</div>

{/* MENU */}
<ul className={`nav-menu ${menuOpen ? "active" : ""}`}>

<li>
<NavLink to="/home" className="nav-link" onClick={()=>setMenuOpen(false)}>
હોમ
</NavLink>
</li>

<li>
<NavLink to="/about" className="nav-link" onClick={()=>setMenuOpen(false)}>
અમારા વિશે
</NavLink>
</li>

<li>
<NavLink to="/gallery" className="nav-link" onClick={()=>setMenuOpen(false)}>
પ્રવૃત્તિઓ
</NavLink>
</li>

<li>
<NavLink to="/join" className="nav-link" onClick={()=>setMenuOpen(false)}>
સંપર્ક કરો
</NavLink>
</li>

</ul>

</nav>
</>
);
};

export default Navbar;